
export const GET_ORGANISATIONS = '[Organisation] Get organisations';
export const GET_ORGANISATIONS_SUCCESS = '[Organisation] Get organisations success';
export const GET_ORGANISATIONS_FAILED = '[Organisation] Get organisations failed';
export const UPDATE_ORGANISATIONS = '[Organisation] Update organisations';
export const LOGIN_TO_ORGANISATION = '[Organisation] Login to organisation';
export const LOGIN_TO_ORGANISATION_FAILED = '[Organisation] Login to organisation failed';
export const PRESELECT_ORGANISATION = '[Organisation] Preselect';